import { type ReactElement } from 'react';
import { type StyrOchStällItem } from '../Sources/StyrOchStällSource';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function StyrOchStällBike(properties: StyrOchStällItem): ReactElement {
    return (
        <PopupTemplateWrapper iconId="bike-station" title="Lånecykel">
            <div className="">
                <h3>Cykel {properties.bikeIds[0]}</h3>
            </div>
        </PopupTemplateWrapper>
    );
}
